import axios from "axios";
import Config from "../../Config";

class AffiliateService {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("dealboxx_token")}`,
      },
    };
  }

  async getAffiliateApplications() {
    try {
      const response = await axios.get(
        `${Config.backendDomain}vendor/affiliate/deals/applied`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message:
          response.data.data.reason || "All applied deals fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message: error.response?.data?.data?.reason || "Failed to fetch all applied deals",
      };
    }
  }



  async approveApplication(applicationId, payload = {}) {
    try {
      const response = await axios.post(
        `${Config.backendDomain}vendor/affiliate/deals/status/update`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.data.reason || "Application approved successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message: error.response?.data?.data?.reason || "Failed to approve application",
      };
    }
  }

  async rejectApplication(applicationId, payload = {}) {
    try {
      const response = await axios.post(
        `${Config.backendDomain}vendor/affiliate/deals/status/update`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.data.reason || "Application rejected successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message: error.response?.data?.data?.reason || "Failed to reject application",
      };
    }
  }

  async getAffiliateDetails(affiliateCode) {
    try {
      const response = await axios.get(
        `${Config.backendDomain}vendor/affiliate/details/${affiliateCode}`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.data.reason || "Affiliate details fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message: error.response?.data?.data?.reason || "Failed to fetch affiliate details",
      };
    }
  }
}
const affiliateService = new AffiliateService();
export default affiliateService;
